export default __webpack_public_path__ + "src/assets/down-caret.e2efbf382ac2186be975eb3a55c7db94.svg";